<template>
  <Transition name="screen">
    <div
      v-if="active"
      class="i-quiz-screen"
    >
      <slot />
    </div>
  </Transition>
</template>

<script setup>
defineProps({ active: Boolean })
</script>

<style lang="scss" scoped>
.i-quiz-screen {
  width: 100%;
  max-width: 600px;
  margin: auto;
  position: relative;

  // Keep in normal flow when active; transition handles enter/leave
}

.screen-enter-active {
  transition:
    opacity 0 cubic-bezier(0.22, 1, 0.36, 1),
    transform 0 cubic-bezier(0.22, 1, 0.36, 1);
  margin: auto;
}

.screen-enter-from {
  opacity: 0;
}

.screen-enter-to {
  opacity: 0;
}

.screen-leave-active {
  opacity: 0;
  transition:
    opacity 0 cubic-bezier(0.22, 1, 0.36, 1),
    transform 0 cubic-bezier(0.22, 1, 0.36, 1);
  margin: auto;
}

.screen-leave-to {
  opacity: 0;
  margin: auto;
}
</style>
